import { IBidCommitteeMemberStatus } from "models/BidCommittee/BidCommitteeMemberStatusModel";
import { BaseService } from "./base.service";

class BidCommitteeMemberStatusServiceInternal extends BaseService {
	getBidCommitteeMemberStatusList = async (): Promise<
		IBidCommitteeMemberStatus[]
	> =>
		this.callApi<IBidCommitteeMemberStatus[]>(
			`BidCommitteeMemberStatus/GetBidCommitteeMemberStatusList`,
			"GET",
			undefined,
			undefined,
			undefined,
			undefined,
			true
		);
}

export const BidCommitteeMemberStatusService =
	new BidCommitteeMemberStatusServiceInternal();
